"use client";

import { Package, ArrowRight, RefreshCw, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Policies() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "Seamless Returns",
    description: "Enjoy hassle-free returns within 30 days of purchase, ensuring complete satisfaction and peace of mind with every order.",
    icon: RefreshCw,
    href: "/ShippingPolicyPage",
    offset: "lg:mt-0"
  }, {
    number: "02",
    title: "Secure Shipping",
    description: "We partner with premium carriers to ensure your Drip District pieces arrive safely and promptly at your doorstep.",
    icon: Package,
    href: "/ShippingPolicyPage",
    offset: "lg:mt-16"
  }, {
    number: "03",
    title: "Quality Guarantee",
    description: "Every piece is meticulously crafted with exceptional materials and rigorous quality standards for lasting elegance.",
    icon: ShieldCheck,
    href: "/BrandStoryPage",
    offset: "lg:-mt-8"
  }];
  return <section data-section-id="5162" id="returnsandpolicies" className="bg-background py-24 md:py-32 lg:py-[140px] overflow-hidden">
      <div className="container mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20 lg:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-7">
            <span className="inline-block text-xs tracking-[0.25em] uppercase font-sans mb-8" style={{
            color: "var(--primary)"
          }}>
              Customer Promise
            </span>
            <h1 className="font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground tracking-tight">
              Shopping with
              <br />
              <span className="italic text-foreground/80">Drip District.</span>
            </h1>
          </div>
        </div>

        {}
        <div ref={gridRef} className="relative grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-1/2 left-[16.66%] right-[16.66%] h-px pointer-events-none" style={{
          backgroundColor: "var(--border)"
        }} />

          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div data-index={i} key={pillar.number} className={`${pillar.offset} transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: gridVisible ? `${i * 150}ms` : "0ms"
          }}>
                <Card className="group relative h-full bg-background border border-border hover:border-accent rounded-lg p-12 md:p-16 transition-all duration-500 ease-out hover:-translate-y-3 hover:shadow-xl shadow-md flex flex-col">
                  <CardContent className="p-0 flex flex-col h-full">
                    <span className="font-sans text-xs tracking-[0.25em] uppercase text-muted-foreground mb-10">
                      {pillar.number} / 03
                    </span>

                    <div className="mb-8">
                      <div className="inline-flex items-center justify-center w-20 h-20 rounded-lg border transition-all duration-500 ease-out group-hover:bg-accent/10 group-hover:border-accent/30" style={{
                    borderColor: "var(--border)"
                  }}>
                        <Icon className="w-8 h-8 transition-all duration-500 ease-out group-hover:text-accent" strokeWidth={1.25} style={{
                      color: "var(--primary)"
                    }} />
                      </div>
                    </div>

                    <h2 className="font-default text-2xl md:text-[28px] leading-tight text-foreground mb-5">
                      {pillar.title}
                    </h2>

                    <p className="font-default text-base leading-relaxed text-muted-foreground mb-10 flex-grow">
                      {pillar.description}
                    </p>

                    <Link to={pillar.href} className="inline-flex items-center gap-2 text-sm font-sans uppercase tracking-[0.2em] text-foreground hover:text-accent transition-colors duration-300 mt-auto">
                      <span>Explore Our Commitment</span>
                      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}